import { ActionState } from './action-state.model';

export class ActionStateCreator {
  public static create(): ActionState {
    return {
      done: false,
      pending: false,
      error: null
    };
  }

  public static onStart(): ActionState {
    return {
      done: false,
      pending: true,
      error: null
    };
  }

  public static onSuccess(): ActionState {
    return {
      done: true,
      pending: false,
      error: null
    };
  }

  public static onError(error: Error): ActionState {
    return {
      done: false,
      pending: false,
      error
    };
  }

  public static reset(): ActionState {
    return {
      done: false,
      pending: false,
      error: null
    };
  }

  public static isInitialState(state: ActionState): boolean {
    const { pending, done, error } = state;
    return !pending && !done && !error;
  }
}
